module.exports = __webpack_public_path__ + "shared/assets/locationicon.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/locationicon.png
// module id = 7551
// module chunks = 0